import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import BreadcrumbsComponent from "../components/Breadcrumbs";
import { useApp } from "../contexts/AppContext";
import { Stack } from "@mui/material";
function TopAppBar() {
  const { breadcrumbs, actions } = useApp();

  return (
    <AppBar
      sx={{
        borderBottom: "1px solid #E7E5E4",
        boxShadow: "none",
        backgroundColor: "white",
        position: "sticky",
        top: 0,
        width: "100%",
      }}
    >
      <Container sx={{paddingX: "80px!important"}}>
        <Toolbar disableGutters>
          <Stack
            width={"100%"}
            direction="row"
            justifyContent={"space-between"}
            alignItems={"center"}
            spacing={2}
          >
            <BreadcrumbsComponent items={breadcrumbs} />
            <Stack direction="row" spacing={2}>
              {actions}
            </Stack>
          </Stack>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default TopAppBar;
